const Data = 


[{
    id: 1,
    name: "Zinger Burger",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    rating: 4,
    price: 25,
    quantity : 1,
    preprice: "30$",
    category: "burger",
    Image: "https://img.freepik.com/free-photo/big-sandwich-hamburger-burger-with-beef-red-onion-tomato-fried-bacon_2829-5398.jpg?t=st=1653947378~exp=1653947978~hmac=9c72f35579233585771a39bd622f718dda183a2c7c286c4cd66027a6f45afeb1&w=740",
    sale: "SALE ON",

    images: [
        {
            image: "https://img.freepik.com/free-photo/big-sandwich-hamburger-burger-with-beef-red-onion-tomato-fried-bacon_2829-5398.jpg?t=st=1653947378~exp=1653947978~hmac=9c72f35579233585771a39bd622f718dda183a2c7c286c4cd66027a6f45afeb1&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
  ],

},

{
    id: 2,
    name: "Grill Burger",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 30,
    rating: 5,
    preprice: "",
    quantity : 1,
    category: "burger",
    Image: "https://img.freepik.com/free-photo/side-view-double-cheeseburger-with-grilled-beef-patties-cheese-lettuce-leaf-burger-buns_141793-4883.jpg?t=st=1653945477~exp=1653946077~hmac=b64eaa792ef988cdc1a450b83e1fea87fbf03ccdef7bbb999b36545f8988ad9c&w=740",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/side-view-double-cheeseburger-with-grilled-beef-patties-cheese-lettuce-leaf-burger-buns_141793-4883.jpg?t=st=1653945477~exp=1653946077~hmac=b64eaa792ef988cdc1a450b83e1fea87fbf03ccdef7bbb999b36545f8988ad9c&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
  ],

},


{
    id: 3,
    name: "Chicken pizza",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 50,
    rating: 3,
    quantity : 1,
    preprice: "",
    category: "pizza",
    Image: "https://img.freepik.com/free-photo/mixed-pizza-with-various-ingridients_140725-3790.jpg?t=st=1653942582~exp=1653943182~hmac=a0ee439a94c972b18a3b63c72efcf40ae4e4d0cac3cde92a7d0847025ccea305&w=740",
    sale: "",
    images: [
        {
            image: "https://img.freepik.com/free-photo/mixed-pizza-with-various-ingridients_140725-3790.jpg?t=st=1653942582~exp=1653943182~hmac=a0ee439a94c972b18a3b63c72efcf40ae4e4d0cac3cde92a7d0847025ccea305&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
  ],
},

{
    id: 4,
    name: "Vegitable Pizza",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 70,
    rating: 4,
    quantity : 1,
    preprice: "",
    category: "pizza",
    Image: "https://img.freepik.com/free-photo/mix-pizza-chicken-tomato-bell-pepper-olives-mushroom-side-view_141793-3167.jpg?t=st=1653942582~exp=1653943182~hmac=a9176cd686ddfb06345127a9ef23c125ef76e05ddbf0a8dbf1756fdcbb4b66b3&w=740",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/mix-pizza-chicken-tomato-bell-pepper-olives-mushroom-side-view_141793-3167.jpg?t=st=1653942582~exp=1653943182~hmac=a9176cd686ddfb06345127a9ef23c125ef76e05ddbf0a8dbf1756fdcbb4b66b3&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
  ],

},

{
    id: 5,
    name: "Beaf Pizza",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 20,
    rating: 5,
    quantity : 1,
    preprice: "40$",
    category: "pizza",
    Image: "https://img.freepik.com/free-photo/pizza-with-salami-tomatoes-olives-cheese-dough-with-whole-wheat-flour-italian-food_2829-6855.jpg?t=st=1654021593~exp=1654022193~hmac=8d8b2471fbeed68805e96958d41361aad2015f258b8911290905cfdb0952b586&w=740",
    sale: "SALE ON",

    images: [
        {
            image: "https://img.freepik.com/free-photo/pizza-with-salami-tomatoes-olives-cheese-dough-with-whole-wheat-flour-italian-food_2829-6855.jpg?t=st=1654021593~exp=1654022193~hmac=8d8b2471fbeed68805e96958d41361aad2015f258b8911290905cfdb0952b586&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
  ],

},


{
    id: 6,
    name: " Chinese Sushi ",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 30,
    rating: 4,
    quantity : 1,
    preprice: "",
    category: "sushi",
    Image: "https://img.freepik.com/free-photo/side-view-mix-sushi-rolls-tray-with-ginger-wasabi_141793-14242.jpg?t=st=1653945937~exp=1653946537~hmac=588b7bf0c7a93e6f0054ffce05b816d14cc2df8bc00ccc4b8150dc7d5c36b91d&w=740",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/side-view-mix-sushi-rolls-tray-with-ginger-wasabi_141793-14242.jpg?t=st=1653945937~exp=1653946537~hmac=588b7bf0c7a93e6f0054ffce05b816d14cc2df8bc00ccc4b8150dc7d5c36b91d&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
  ],

},


{
    id: 7,
    name: " philadelphia roll ",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 36,
    rating: 4,
    preprice: "",
    quantity : 1,
    category: "sushi",
    Image: "https://img.freepik.com/free-photo/side-view-philadelphia-roll-with-conger-eel-crab-meat-avocado-cucumber-teriyaki-sauce-ginger-wasabi-tray_141793-5046.jpg?t=st=1653945937~exp=1653946537~hmac=5dbf15b3147b7ef13ebbed7909634bcc664f6883a7ed0ad940abdb5253ff608b&w=740",
    sale: "",


    images: [
        {
            image: "https://img.freepik.com/free-photo/side-view-philadelphia-roll-with-conger-eel-crab-meat-avocado-cucumber-teriyaki-sauce-ginger-wasabi-tray_141793-5046.jpg?t=st=1653945937~exp=1653946537~hmac=5dbf15b3147b7ef13ebbed7909634bcc664f6883a7ed0ad940abdb5253ff608b&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
  ],

},

{
    id: 8,
    name: "Greek salad ",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 10,
    rating: 5,
    quantity : 1,
    preprice: "",
    category: "salat",
    Image: "https://img.freepik.com/free-photo/greek-salad-with-fresh-vegetables-feta-cheese-kalamata-olives_2829-10848.jpg?t=st=1653944564~exp=1653945164~hmac=694f3fbf82c7016240f1f740f35b9cdcdb77b295d915f6d0b2f7441a4ff54493&w=826",
    sale: "",
    images: [
        {
            image: "https://img.freepik.com/free-photo/greek-salad-with-fresh-vegetables-feta-cheese-kalamata-olives_2829-10848.jpg?t=st=1653944564~exp=1653945164~hmac=694f3fbf82c7016240f1f740f35b9cdcdb77b295d915f6d0b2f7441a4ff54493&w=826",
  },
  {
        image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
  ],

},

{
    id: 9,
    name: "chicken salad",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 15,
    rating: 3,
    quantity : 1,
    preprice: "20$",
    category: "salat",
    Image: "https://img.freepik.com/free-photo/salad-chicken-breast-with-zucchini-cherry-tomatoes_2829-8505.jpg?t=st=1653944564~exp=1653945164~hmac=2713898100f68d20187f4ad4d28f8306d6a1bc504eddd83e4abc900a6c157511&w=740",
    sale: "SALE ON",

    images: [
        {
            image: "https://img.freepik.com/free-photo/salad-chicken-breast-with-zucchini-cherry-tomatoes_2829-8505.jpg?t=st=1653944564~exp=1653945164~hmac=2713898100f68d20187f4ad4d28f8306d6a1bc504eddd83e4abc900a6c157511&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
  ],
},

{
    id: 10,
    name: "Chocolate cake",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 22,
    quantity : 1,
    rating: 5,
    preprice: "",
    category: "desert",
    Image: "https://img.freepik.com/free-photo/front-view-sweet-chocolate-cake_23-2148834059.jpg?t=st=1654021012~exp=1654021612~hmac=b385af82d89fb8acbd77c635bc6853c34565033021c38c9a45f8d303a735e1f1&w=900",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/front-view-sweet-chocolate-cake_23-2148834059.jpg?t=st=1654021012~exp=1654021612~hmac=b385af82d89fb8acbd77c635bc6853c34565033021c38c9a45f8d303a735e1f1&w=900",
  },
  {
        image: "https://img.freepik.com/free-photo/sponge-cake-with-strawberries-top_144627-45517.jpg?t=st=1654889048~exp=1654889648~hmac=2401a3a76cb5174dab4308210a31609252f7e0381ec605f6b8d12e862969e71c&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/assortment-pieces-cake_114579-28298.jpg?t=st=1654889048~exp=1654889648~hmac=e0f48369eefeaa89e954ec6f3dac8a179a3bf872fd385b06f720d7c42b4fda75&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/stunning-birthday-cake-covered-with-pink-icing-roses_8353-1076.jpg?t=st=1654889048~exp=1654889648~hmac=51e0b8842f21bd8981ad8fa2406f10145b170fe8e0454af69e1c3808c29476d9&w=740",
},
  ],
},

{
    id: 11,
    name: "Cheese Burger",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 50,
    rating: 3,
    quantity : 1,
    preprice: "",
    category: "burger",
    Image: "https://img.freepik.com/free-photo/front-view-burger-stand_141793-15542.jpg?t=st=1654017967~exp=1654018567~hmac=8cd7f77f28e287a45a2b0c9e26c408993116ab12a5a122253a576275077e7d3f&w=740",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/front-view-burger-stand_141793-15542.jpg?t=st=1654017967~exp=1654018567~hmac=8cd7f77f28e287a45a2b0c9e26c408993116ab12a5a122253a576275077e7d3f&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
  ],

},

{
    id: 12,
    name: "Beaf Burger",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 46,
    rating: 3,
    quantity : 1,
    preprice: "",
    category: "burger",
    Image: "https://img.freepik.com/free-photo/chicken-burger-wooden-board-side-view_141793-2753.jpg?t=st=1654000347~exp=1654000947~hmac=ba3050dcdafc6a516a27a90c676c524253807dc30f951b0c45f7e865bb8bc9a3&w=740",
    sale: "",
    images: [
        {
            image: "https://img.freepik.com/free-photo/chicken-burger-wooden-board-side-view_141793-2753.jpg?t=st=1654000347~exp=1654000947~hmac=ba3050dcdafc6a516a27a90c676c524253807dc30f951b0c45f7e865bb8bc9a3&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
  ],
},

{
    id: 13,
    name: "Russian salad",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 23,
    rating: 4,
    quantity : 1,
    preprice: "20$",
    category: "salat",
    Image: "https://img.freepik.com/free-photo/salad-with-tuna-tomatoes-potato-onion_2829-10301.jpg?t=st=1654020292~exp=1654020892~hmac=5fac5ecd6e6573ff14240bd1a4081de086dd39956d3bcedb7deaa1f9f1465a5f&w=740",
    sale: "SALE ON",

    images: [
        {
            image: "https://img.freepik.com/free-photo/salad-with-tuna-tomatoes-potato-onion_2829-10301.jpg?t=st=1654020292~exp=1654020892~hmac=5fac5ecd6e6573ff14240bd1a4081de086dd39956d3bcedb7deaa1f9f1465a5f&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
  ],
},
{
    id: 14,
    name: "Fruits salad",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 12,
    rating: 4,
    quantity : 1,
    preprice: "",
    category: "salat",
    Image: "https://img.freepik.com/free-photo/top-view-delicious-fruit-salad-inside-plate-with-fresh-fruits-gray-fruit-tree-exotic-tropical-photo-ripe-diet_140725-109945.jpg?t=st=1654020292~exp=1654020892~hmac=7b29995dd7eeccabfc6467fb6ae3fe191d06fb4432e600d909edbb67180db4ab&w=740",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/top-view-delicious-fruit-salad-inside-plate-with-fresh-fruits-gray-fruit-tree-exotic-tropical-photo-ripe-diet_140725-109945.jpg?t=st=1654020292~exp=1654020892~hmac=7b29995dd7eeccabfc6467fb6ae3fe191d06fb4432e600d909edbb67180db4ab&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
  ],
},

{
    id: 15,
    name: "Cheese Pizza",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 32,
    rating: 5,
    quantity : 1,
    preprice: "",
    category: "pizza",
    Image: "https://img.freepik.com/free-photo/traditional-supreme-pizza-rustic-wooden-table_123827-20264.jpg?t=st=1654021593~exp=1654022193~hmac=2d5955bc39647a52766d496b74e66602764516189faed64b84cac8f752a3993e&w=740",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/traditional-supreme-pizza-rustic-wooden-table_123827-20264.jpg?t=st=1654021593~exp=1654022193~hmac=2d5955bc39647a52766d496b74e66602764516189faed64b84cac8f752a3993e&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
  ],

},

{
    id: 16,
    name: "Korean Sushi",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 50,
    rating: 5,
    quantity : 1,
    preprice: "",
    category: "sushi",
    Image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-43007.jpg?t=st=1654020709~exp=1654021309~hmac=2c3503627c0ca108b1a91aa7688fcd59e491ab2b970822ab29785af3888fff11&w=740",
    sale: "",

    
    images: [
        {
            image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-43007.jpg?t=st=1654020709~exp=1654021309~hmac=2c3503627c0ca108b1a91aa7688fcd59e491ab2b970822ab29785af3888fff11&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
  ],
},

{
    id: 17,
    name: "Traditional Sushi",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 33,
    quantity : 1,
    rating: 3,
    preprice: "",
    category: "sushi",
    Image: "https://img.freepik.com/free-photo/traditional-sushi-dark-surface_1150-42063.jpg?t=st=1654020709~exp=1654021309~hmac=18828f5b829cdefbdc331c2e507ee5cacc9cd447f822010e66e8dab95978cfa0&w=740",
    sale: "",
    
    images: [
        {
            image: "https://img.freepik.com/free-photo/traditional-sushi-dark-surface_1150-42063.jpg?t=st=1654020709~exp=1654021309~hmac=18828f5b829cdefbdc331c2e507ee5cacc9cd447f822010e66e8dab95978cfa0&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
  ],
},

{
    id: 18,
    name: "Ice Cone",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 24,
    quantity : 1,
    rating: 4,
    preprice: "30$",
    category: "desert",
    Image: "https://img.freepik.com/free-photo/top-view-set-ice-cream-cones-with-chocolate_23-2148425392.jpg?t=st=1654021066~exp=1654021666~hmac=9e462a69a5a7dd5c4b5305d4219e025abc29ad60bffb6941a3acca4c0f681761&w=740",
    sale: "SALE ON",

  
    images: [
        {
            image: "https://img.freepik.com/free-photo/top-view-set-ice-cream-cones-with-chocolate_23-2148425392.jpg?t=st=1654021066~exp=1654021666~hmac=9e462a69a5a7dd5c4b5305d4219e025abc29ad60bffb6941a3acca4c0f681761&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/ice-cream-cone_144627-41497.jpg?t=st=1654889259~exp=1654889859~hmac=87242439c775f68064a293a6deb8cbe23becce466ba5d50dee9b082c36a358c0&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/top-view-homemade-ice-cream-scoops-concept_23-2148425380.jpg?t=st=1654889310~exp=1654889910~hmac=fbacb7be231b700ddaef9114b9533bf89571d179a17375f97241df08c0cb23db&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/ice-cream-with-bananas-chocolate-sprinkles-white-plate_114579-33759.jpg?t=st=1654889401~exp=1654890001~hmac=7fb9105f6717da2d2886c995299c5a5df7217d9821c830807cea0e85b607013b&w=740",
},
  ],

},

{
    id: 19,
    name: "Chocolate Ice Cream",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 21,
    rating: 5,
    quantity : 1,
    preprice: "",
    category: "desert",
    Image: "https://img.freepik.com/free-photo/chocolate-ice-cream-dessert_144627-8363.jpg?t=st=1654021235~exp=1654021835~hmac=9b373d5f0695bf7976867710d69845cc7a5f8f4484b2d6868ce7df3133a9157a&w=826",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/chocolate-ice-cream-dessert_144627-8363.jpg?t=st=1654021235~exp=1654021835~hmac=9b373d5f0695bf7976867710d69845cc7a5f8f4484b2d6868ce7df3133a9157a&w=826",
  },
  {
        image: "https://img.freepik.com/free-photo/ice-cream-cone_144627-41497.jpg?t=st=1654889259~exp=1654889859~hmac=87242439c775f68064a293a6deb8cbe23becce466ba5d50dee9b082c36a358c0&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/top-view-homemade-ice-cream-scoops-concept_23-2148425380.jpg?t=st=1654889310~exp=1654889910~hmac=fbacb7be231b700ddaef9114b9533bf89571d179a17375f97241df08c0cb23db&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/ice-cream-with-bananas-chocolate-sprinkles-white-plate_114579-33759.jpg?t=st=1654889401~exp=1654890001~hmac=7fb9105f6717da2d2886c995299c5a5df7217d9821c830807cea0e85b607013b&w=740",
},
  ],
},

{
    id: 20,
    name: "Doner",
    description: "This impressive paella is a perfect party dish and a fun meal to cook",
    detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
    price: 31,
    rating: 5,
    quantity : 1,
    preprice: "",
    category: "desert",
    Image: "https://img.freepik.com/free-photo/side-view-doner-with-grilled-chicken-greens-lettuce-tomato-french-fries-table_141793-4881.jpg?t=st=1654021343~exp=1654021943~hmac=a091ec9468a91768cbea2d4aba6fbf0c42461439ec8644eddd96d825d6c4fb68&w=740",
    sale: "",

    images: [
        {
            image: "https://img.freepik.com/free-photo/side-view-doner-with-grilled-chicken-greens-lettuce-tomato-french-fries-table_141793-4881.jpg?t=st=1654021343~exp=1654021943~hmac=a091ec9468a91768cbea2d4aba6fbf0c42461439ec8644eddd96d825d6c4fb68&w=740",
  },
  {
        image: "https://img.freepik.com/free-photo/side-view-chicken-doner-with-greens-cucumber-tomato-sauce-cucumber-red-onion-pita-slice-lemon-board_141793-4824.jpg?t=st=1654889485~exp=1654890085~hmac=a7d98af3b125f9cb719c7cd32451305bf8bd78256aef1f29bc4d0a9c31b62c50&w=740",
  },
{
        image: "https://img.freepik.com/free-photo/side-view-chicken-doner-with-gren-salad-french-fries_141793-2684.jpg?t=st=1654873556~exp=1654874156~hmac=f4ffddcbab0b278fe0edbcc1a6eb0895175fe24186763b3aae3195b6a98ca78e&w=740",
},
{  
        image: "https://img.freepik.com/free-photo/chicken-wrap-doner-with-tomato_140725-10509.jpg?t=st=1654889485~exp=1654890085~hmac=0d2bd8fd1f7995e8f6516763c2c3f77ae1ae2c6475dc2e839aa13b429ae12085&w=740",
},
  ],

},


// {
//     id: 21,
//     name: "Zinger Burger",
//     description: "This impressive paella is a perfect party dish and a fun meal to cook",
//     price: 25,
//     preprice: "30$",
//     category: "burger",
//     Image: "https://img.freepik.com/free-photo/big-sandwich-hamburger-burger-with-beef-red-onion-tomato-fried-bacon_2829-5398.jpg?t=st=1653947378~exp=1653947978~hmac=9c72f35579233585771a39bd622f718dda183a2c7c286c4cd66027a6f45afeb1&w=740",
//     sale: "SALE ON"
// },

]


export default Data;